export default "__VITE_ASSET__b01fbaa1__"